var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutgoing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20005 17.5998H16.8C17.24 17.5998 17.6 17.2398 17.6 16.7998V12.7998C17.6 12.3598 17.96 11.9998 18.4 11.9998C18.84 11.9998 19.2 12.3598 19.2 12.7998V17.5998C19.2 18.4798 18.48 19.1998 17.6 19.1998H6.40005C5.52005 19.1998 4.80005 18.4798 4.80005 17.5998V6.3998C4.80005 5.5198 5.51205 4.7998 6.40005 4.7998H11.2C11.64 4.7998 12 5.1598 12 5.5998C12 6.0398 11.64 6.3998 11.2 6.3998H7.20005C6.76005 6.3998 6.40005 6.7598 6.40005 7.1998V16.7998C6.40005 17.2398 6.76005 17.5998 7.20005 17.5998ZM14.4 6.3998C13.96 6.3998 13.6 6.0398 13.6 5.5998C13.6 5.1598 13.96 4.7998 14.4 4.7998H19.2V9.5998C19.2 10.0398 18.84 10.3998 18.4 10.3998C17.96 10.3998 17.6 10.0398 17.6 9.5998V7.5278L10.296 14.8318C9.98405 15.1438 9.48005 15.1438 9.16805 14.8318C8.85605 14.5198 8.85605 14.0158 9.16805 13.7038L16.472 6.3998H14.4Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutgoing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/outgoing.9ea9f61b91cb06fd301cf87abc3851a9.svg";